import { reportUncaughtError } from '~/utils/errorReporting'

// Vue catches whatever a component throws -- in an event handler, a watcher, a lifecycle
// hook, a render -- and Nuxt removes its own handler once the app has mounted. In
// production such an error is only written to the console: it never becomes a window
// `error` event, which is all App Insights collects by itself, so it was invisible.
//
// A NuxtError is left out: it is raised on purpose (a 404) or is on its way to the error
// page, which reports itself (app/error.vue).
export default defineNuxtPlugin({
  name: 'error-reporting',
  setup (nuxtApp) {
    nuxtApp.hook('vue:error', (error, _instance, info) => {
      if (!isNuxtError(error)) {
        reportUncaughtError(error, nuxtApp.$appInsights, info)
      }
    })
  }
})
